<div class="d-flex flex-column py-1 mb-5">
  <div>{{ name }}</div>
  <div class="fs-2xs mb-2">{{ metric?.name }}</div>
  @if (metric?.legend?.type == 'static') {
    <div class="d-flex gap-2">
      @for (content of metric?.legend?.items; track content) {
        <app-legend-item
          class="flex-grow-1"
          [description]="content.description"
          [value]="content.value"
          [type]="metric?.legend?.type"
        >
        </app-legend-item>
      }
    </div>
  }
</div>
